import React, { Component } from "react"
import ReactDOM from "react-dom"

import AccommodationsList from '../../accommodations/list'

export default class Recent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <AccommodationsList {...this.props} />
  }
}
